import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import clsx from 'clsx';
import {
    Typography,
    Grid,
    Chip,
    InputLabel,
    Select,
    MenuItem,
    InputAdornment,
    Divider,
    Autocomplete,
    Box,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';


import { getperiod, minStopOptions } from '../../utils/datePeriodCalculator';
import { GENSET_TAMPER_REPORT_TYPE, reportTypes, defaultReport, advancedReports } from '../../utils/reportTypes';
import { ruleNames } from '../../utils/ruleNames';
import { buildReportMulti, buildReportOne } from '../../features/datacenter/reportSlice';
import { userSelector } from '../../features/user/UserSlice';
import { selectRouteListAll, selectRouteListLoaded } from '../../features/tripcenter/routeSlice';
import { getRouteList } from '../../features/tripcenter/routeApi';

import ZoneMultiSelect from '../common/ZoneMultiSelect';
import VehicleMultiSelect from '../common/VehicleMultiSelect';
import GetPeriod from '../common/GetPeriod';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 200,
    },
}));


const GetReportForm = ({ reportFormOpen, handleReportFormClose }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const user = useSelector(userSelector);
    const routeList = useSelector(selectRouteListAll);
    const routeListLoaded = useSelector(selectRouteListLoaded);
    const [reportOptions, setReportOptions] = useState([]);
    useEffect(() => {
        if (user.priviledge === 'subuser') {
            let accesslist = [...defaultReport];
            advancedReports.forEach(r => {
                user.reports.forEach(ur => {
                    if (ur.name === r.name && ur.type === r.value) {
                        accesslist.push(r);
                    }
                })
            })
            setReportOptions(accesslist);
        } else {
            setReportOptions(reportTypes);
        }
    }, [user])

    const [advanced, setAdvanced] = useState(false);
    const [showAllVehiclesSelectOption, setshowAllVehiclesSelectOption] = useState(false);
    const [multiVehicles, setMultiVehicles] = useState([]);
    const [multiAssetIds, setMultiAssetIds] = useState([]);
    const [multiZones, setMultiZones] = useState([]);
    const [multiZoneIds, setMultiZoneIds] = useState([]);
    const [periodType, setPeriodType] = useState('today');
    const [fromDate, setFromDate] = useState(getperiod(periodType).fromDate);
    const [toDate, setToDate] = useState(getperiod(periodType).toDate);
    const [eventDesc, setEventDesc] = useState("");
    const [routeSelection, setRouteSelection] = useState(null);
    const [routeInput, setRouteInput] = useState('');
    const [multiRoutes, setMultiRoutes] = useState([]);
    const [selectedRules, setSelectedRules] = useState([]);
    const [crawl, setCrawl] = useState(false);
    const [reportType, setReportType] = useState("");
    const [minStop, setMinStop] = useState(5);
    const [minDrive, setMinDrive] = useState(1);
    const [speedLimit, setSpeedLimit] = useState(60);
    const [minActive, setMinActive] = useState(5);
    const [hold, setHold] = useState(2);
    const [minTemp, setMinTemp] = useState(15);
    const [maxTemp, setMaxTemp] = useState(25);
    const [currentEmail, setCurrentEmail] = useState('')
    const [emails, setEmails] = useState([]);
    const [emailPDF, setEmailPDF] = useState(false);
    const [mapNeeded, setMapNeeded] = useState(false);
    const [interval, setInterval] = useState(15);
    const [accurateKm, setAccurateKm] = useState(false);

    const onFromDateChange = (value, ptype = "custom") => {
        //console.log("From date change", value, ptype);
        setFromDate(value);
        setPeriodType(ptype);
    }

    const onToDateChange = (value, ptype = "custom") => {
        //console.log("TO date change", value);
        setToDate(value);
        setPeriodType(ptype);
    }


    //console.log("Form ptype", periodType);

    const onReportTypeChange = (e) => {
        console.log("report type", e.target.value);
        const selectedReportType = e.target.value;
        const isGensetTamper = selectedReportType.value === GENSET_TAMPER_REPORT_TYPE;
        setReportType(selectedReportType);
        if (selectedReportType.value.search('fuelactivity') !== -1) {
            setCrawl(true);
        }/*  else {
            setCrawl(false);
        } */
        if (selectedReportType.mapOption) {
            setMapNeeded(true);
        } else {
            setMapNeeded(false);
        }
        if (isGensetTamper) {
            setEmailPDF(false);
            setMapNeeded(false);
        }
        if (selectedReportType.value === 'travel_path') {
            setInterval(60);
            setAccurateKm(false);
        } else {
            setAccurateKm(false);
        }
        if (selectedReportType.value === 'binarysensor') {
            if(selectedReportType.eventName){
                setEventDesc(selectedReportType.eventName);
            } else {
                setEventDesc(selectedReportType.name);
            }
            
        }
        if (selectedReportType.multiVehicle || selectedReportType.routeSelection) {
            //console.log("Multi vehicle option take");
            setshowAllVehiclesSelectOption(true);
        } else {
            setshowAllVehiclesSelectOption(false);
        }
        if (!selectedReportType.routeSelection) {
            setRouteSelection(null);
            setRouteInput('');
            setMultiRoutes([]);
        }
        if (!selectedReportType.ruleSelection) {
            setSelectedRules([]);
        }
    }

    const onMinStopChange = (e) => {
        setMinStop(e.target.value);
    }

    const onMinDriveChange = (e) => {
        setMinDrive(e.target.value);
    }

    const onSpeedLimitChange = (e) => {
        setSpeedLimit(e.target.value);
    }

    const onMinActiveChange = (e) => {
        setMinActive(e.target.value);
    }

    const onHoldChange = (e) => {
        setHold(e.target.value);
    }

    const onMinTempChange = (e) => {
        setMinTemp(e.target.value);
    }

    const onMaxTempChange = (e) => {
        setMaxTemp(e.target.value);
    }

    const onIntervalChange = (e) => {
        setInterval(e.target.value);
    }

    const onEmailPdfChange = (emailPDF) => {
        setEmailPDF(!emailPDF);
    }

    const addEmails = () => {
        if (emails.indexOf(currentEmail) === -1) {
            setEmails([...emails, currentEmail]);
            setCurrentEmail('');
        }
    }
    const emailDelete = (email) => {
        const index = emails.indexOf(email);
        if (index !== -1) {
            let newe = [...emails];
            newe.splice(index, 1);
            setEmails(newe);
        }
    }

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    const [formerr, setFormerr] = useState([]);
    const [submitDisabled, setsubmitDisabled] = useState(false);

    useEffect(() => {
        if (reportType && reportType.routeSelection && (routeList?.length === 0 || !routeListLoaded)) {
            dispatch(getRouteList());
        }
    }, [dispatch, reportType, routeList, routeListLoaded]);

    const formatRouteLabel = (route) => {
        if (!route) {
            return '';
        }
        const routeNumber = route.routeNumber !== undefined && route.routeNumber !== null ? route.routeNumber : '';
        const routeNameValue = route.routeName || '';
        if (routeNumber !== '' && routeNameValue) {
            return `#${routeNumber} | ${routeNameValue}`;
        }
        return routeNameValue || `${routeNumber}`;
    };

    const isDeletedRouteName = (name) => typeof name === 'string' && name.includes('[DELETED]');
    const selectedRouteIsDeleted = isDeletedRouteName(routeSelection?.routeName);

    const addRouteSelection = (selectedRoute) => {
        if (!selectedRoute) {
            return;
        }
        const routeEntry = {
            routeName: selectedRoute.routeName || '',
            routeNumber: selectedRoute.routeNumber,
        };
        setMultiRoutes((prevRoutes) => {
            const exists = prevRoutes.some(route =>
                route.routeName === routeEntry.routeName && route.routeNumber === routeEntry.routeNumber
            );
            if (exists) {
                return prevRoutes;
            }
            return [...prevRoutes, routeEntry];
        });
        setRouteSelection(selectedRoute);
    };

    const removeRouteSelection = (routeToRemove) => {
        const updatedRoutes = multiRoutes.filter(route =>
            !(route.routeName === routeToRemove.routeName && route.routeNumber === routeToRemove.routeNumber)
        );
        setMultiRoutes(updatedRoutes);
    };

    const ruleOptions = Object.keys(ruleNames).map((key) => ({
        id: key,
        value: key,
        label: ruleNames[key],
    }));

    const sendDisable = useCallback(
        () => {
            let errMessage = [];
            let disabled = false;
            //console.log("Report type check", reportType);
            //console.log("Email PDF check", emailPDF);
            //console.log("Email count check", emails.length);
            //console.log("From date check", fromDate);;
            //console.log("To Date check", toDate);
            //console.log("vehicles check", multiAssetIds.length);

            if (emailPDF) {
                if (emails.length === 0) {
                    disabled = true;
                    errMessage.push(`Add atleast one email address`);
                }
            }

            if (reportType === "") {

                disabled = true;
                errMessage.push(`Select Report type`);
            }

            if (multiAssetIds.length === 0) {
                disabled = true;
                errMessage.push(`Select atleast one vehicle`);
            }

            if (!fromDate) {
                disabled = true;
                errMessage.push(`Report Period from date not set`);
            }

            if (!toDate) {
                disabled = true;
                errMessage.push(`Report Period to date not set`);
            }

            if (toDate && fromDate) {
                if (toDate.isSameOrBefore(fromDate)) {
                    disabled = true;
                    errMessage.push(`Report Period Start date must be before the End date`);
                }
            }

            if (reportType && reportType.value === 'travel_path') {
                const intervalValue = Number(interval);
                if (!Number.isFinite(intervalValue) || intervalValue <= 0 || intervalValue % 15 !== 0 || intervalValue > 1440) {
                    disabled = true;
                    errMessage.push(`Travel Path interval must be a positive multiple of 15 minutes and not more than 1440 minutes`);
                }
                if (multiAssetIds.filter(a => a !== '').length > 1) {
                    disabled = true;
                    errMessage.push(`Travel Path report supports one vehicle at a time`);
                }
            }

            setFormerr(errMessage);
            setsubmitDisabled(disabled);
            return disabled;
        },
        [emailPDF, emails, reportType, fromDate, toDate, multiAssetIds, interval],
    );

    useEffect(() => {
        sendDisable();
    }, [sendDisable, emailPDF, emails, reportType, fromDate, toDate, multiAssetIds]);

    const submitForm = () => {
        const masid = multiAssetIds.filter(a => a !== '');
        const mveh = multiVehicles.filter(a => a !== '');
        const selectedRouteNames = multiRoutes.map(route => route.routeName).filter(Boolean);
        const selectedRouteNumbers = multiRoutes.map(route => route.routeNumber).filter(routeNumber => routeNumber !== undefined && routeNumber !== null && routeNumber !== '');
        const reportParams = {
            assetIds: masid,
            assets: mveh,
            zoneIds: multiZoneIds,
            zones: multiZones,
            reportType,
            minStop: minStop * 60 * 1000,
            minDrive,
            minActive,
            hold,
            speedLimit,
            timeFrom: fromDate.format('YYYY-MM-DD HH:mm:ss'),
            timeTo: toDate.format('YYYY-MM-DD HH:mm:ss'),
            mapNeeded,
            emailPDF,
            emails,
            event_desc: eventDesc,
            crawl,
            minTemp,
            maxTemp,
            interval,
            //compliance: null,
        };
        if (reportType.value === 'travel_path') {
            reportParams.accurateKm = accurateKm;
        }
        if (reportType.value === GENSET_TAMPER_REPORT_TYPE) {
            reportParams.includeAddresses = true;
            reportParams.includeDebug = false;
            reportParams.emailPDF = false;
            reportParams.emails = [];
        }
        if (selectedRouteNames.length > 0) {
            reportParams.routeNames = selectedRouteNames;
        }
        if (selectedRouteNumbers.length > 0) {
            reportParams.routeNumbers = selectedRouteNumbers;
        }
        if (selectedRules.length > 0) {
            reportParams.ruleNames = selectedRules;
        }
        console.log("Report submitted", reportParams);
        if (reportType.multiVehicle) {
            dispatch(buildReportMulti(reportParams));
        } else {
            dispatch(buildReportOne(reportParams));
        }
        /* if (window.location.href.indexOf("localhost") !== -1) {
            //resetForm();
        } else {
            console.log("No reset in dev");
        } */
        
        handleReportFormClose();
        //TODO enable the above
    }

    const resetForm = () => {
        //console.log("Before reset", fromDate);
        setMultiVehicles([]);
        setMultiAssetIds([]);
        setMultiZoneIds([]);
        setMultiZones([]);
        setPeriodType('today');
        setFromDate(getperiod(periodType).fromDate);
        setToDate(getperiod(periodType).toDate);
        setEventDesc("");
        setRouteSelection(null);
        setRouteInput('');
        setMultiRoutes([]);
        setSelectedRules([]);
        setCrawl(false);
        setReportType("");
        setCurrentEmail("");
        setEmails([]);
        setEmailPDF(false);
        setMapNeeded(false);
        setMinStop(5);
        setMinDrive(1);
        setMinActive(5);
        setHold(0);
        setMinTemp(15);
        setMaxTemp(25);
        setInterval(15);
        setAccurateKm(false);
        setAdvanced(false);
        setshowAllVehiclesSelectOption(false);
        //console.log("After reset", fromDate);
    }

    const closeForm = () => {
        //resetForm();
        handleReportFormClose();
    }

    const reportSupportsPdf = reportType === "" || reportType.pdfSupported !== false;

    return (
        <Dialog open={reportFormOpen} onClose={handleReportFormClose} fullWidth>
            <DialogTitle><b style={{ color: 'DodgerBlue' }}>Report Form</b></DialogTitle>
            <Divider />
            <Grid container spacing={1} style={{ width: '600px' }}>
                <Grid item container sm={6} spacing={1}>
                    <DialogContent>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="reportTypeLabel">Report Type</InputLabel>
                            <Select
                                variant="standard"
                                labelId="reportTypeLabel"
                                id="reportTypeSelect"
                                value={reportType}
                                onChange={onReportTypeChange}
                            >
                                {
                                    reportOptions.map(ev => <MenuItem key={ev.name} value={ev}>{ev.name}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogContent>

                        <VehicleMultiSelect
                            multiVehicles={multiVehicles}
                            setMultiVehicles={setMultiVehicles}
                            multiAssetIds={multiAssetIds}
                            setMultiAssetIds={setMultiAssetIds}
                            showAllVehiclesSelectOption={showAllVehiclesSelectOption}
                        />

                        <GetPeriod
                            fromDate={fromDate}
                            onFromDateChange={onFromDateChange}
                            toDate={toDate}
                            onToDateChange={onToDateChange}
                            periodType={periodType}
                        />
                    </DialogContent>


                </Grid>
                <Grid item container sm={6} spacing={1}>
                    {
                        reportType !== "" &&
                        <DialogContent>
                            <FormControlLabel
                                control={<Checkbox checked={advanced} onChange={() => setAdvanced(!advanced)} name="Advanced" />}
                                label="Show Advanced Options"
                            />
                        </DialogContent>
                    }
                    {
                        advanced &&
                        <DialogContent>

                            {
                                reportType.routeSelection &&
                                <FormControl className={classes.formControl}>
                                    <Autocomplete
                                        options={routeList || []}
                                        getOptionLabel={formatRouteLabel}
                                        value={routeSelection}
                                        onChange={(event, newValue) => {
                                            event?.preventDefault?.();
                                            addRouteSelection(newValue);
                                        }}
                                        inputValue={routeInput}
                                        onInputChange={(event, newInputValue) => setRouteInput(newInputValue)}
                                        isOptionEqualToValue={(option, value) =>
                                            option.routeName === value.routeName && option.routeNumber === value.routeNumber
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                label="Route Selection"
                                                placeholder="Select route..."
                                                sx={{
                                                    '& .MuiInputBase-input': {
                                                        color: selectedRouteIsDeleted ? 'error.main' : 'inherit'
                                                    }
                                                }}
                                            />
                                        )}
                                        renderOption={(props, option) => {
                                            const isDeleted = isDeletedRouteName(option.routeName);

                                            return (
                                                <Box component="li" {...props}>
                                                    <Typography sx={{ color: isDeleted ? 'error.main' : 'text.primary' }}>
                                                        {formatRouteLabel(option)}
                                                    </Typography>
                                                </Box>
                                            );
                                        }}
                                    />
                                </FormControl>
                            }
                            {
                                reportType.routeSelection && multiRoutes.length > 0 &&
                                <Grid container spacing={1}>
                                    {multiRoutes.map(route => (
                                        <Grid item key={`${route.routeNumber || ''}-${route.routeName}`}>
                                            <Chip
                                                size="small"
                                                label={formatRouteLabel(route)}
                                                onDelete={() => removeRouteSelection(route)}
                                                color="primary"
                                                variant="outlined"
                                                sx={{
                                                    margin: '5px',
                                                    '& .MuiChip-deleteIcon': {
                                                        order: -1,
                                                        marginRight: '4px',
                                                        marginLeft: 0,
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            }
                            {
                                reportType.ruleSelection &&
                                <FormControl className={classes.formControl}>
                                    <Autocomplete
                                        multiple
                                        options={ruleOptions}
                                        getOptionLabel={(option) => option.label}
                                        value={ruleOptions.filter(option => selectedRules.includes(option.value))}
                                        onChange={(event, newValue) => {
                                            event?.preventDefault?.();
                                            setSelectedRules(newValue.map(option => option.value));
                                        }}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                label="Rule Selection"
                                                placeholder="Select rules..."
                                            />
                                        )}
                                    />
                                </FormControl>
                            }
                            {
                                    (reportType.value === 'binarysensor' || reportType.value.search('fuel') !== -1) &&
                                <FormControl className={classes.formControl}>
                                    <FormControlLabel
                                        control={<Checkbox checked={crawl} onChange={() => setCrawl(!crawl)} name="crawl" />}
                                        label={<Typography variant="body1"><span style={{ color: 'red' }}>Rebuild from raw data - Caution!</span></Typography>}
                                    />
                                    {
                                        crawl &&
                                        <Typography variant="subtitle2">
                                            Use this option if and only if the normal report is wrong or inconsistent. This takes a lot of time. The report data may change over time.
                                            Contact technical support if you are confused about this option.
                                        </Typography>
                                    }
                                </FormControl>
                            }
                            {
                                reportType.minActive &&
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        variant="standard"
                                        label="Minimum Sensor Activity Time"
                                        name="minActive"
                                        value={minActive}
                                        onChange={onMinActiveChange}
                                        type="number"
                                        id="standard-start-adornment"
                                        className={clsx(classes.margin, classes.textField)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">Minutes</InputAdornment>,
                                            step: 1,
                                            inputProps: {
                                                min: 0, step: 1,
                                            }
                                        }}
                                    />
                                </FormControl>
                            }
                            {
                                reportType.value === 'binarysensor' &&
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        variant="standard"
                                        label="Sensor Activity Smoothing"
                                        name="hold"
                                        value={hold}
                                        onChange={onHoldChange}
                                        type="number"
                                        id="standard-start-adornment"
                                        className={clsx(classes.margin, classes.textField)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">Minutes</InputAdornment>,
                                            step: 1,
                                            inputProps: {
                                                min: 0, step: 1,
                                            }
                                        }}
                                    />
                                </FormControl>
                            }
                            {
                                reportType.minStopDrive &&
                                <FormControl className={classes.formControl}>
                                    <InputLabel id="minStopLabel">Minimum Stoppage Time</InputLabel>
                                    <Select
                                        variant="standard"
                                        labelId="minStopLabel"
                                        id="minStopSelect"
                                        value={minStop}
                                        onChange={onMinStopChange}
                                    >
                                        {
                                            minStopOptions.map(ev => <MenuItem key={ev.value} value={ev.value}>{ev.name}</MenuItem>)
                                        }
                                        <MenuItem key={"custom"} value={"custom"}>{"Custom"}</MenuItem>
                                    </Select>
                                </FormControl>
                            }
                            {
                                reportType.minStopDrive &&
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        variant="standard"
                                        label="Minimum Drive Distance"
                                        name="minDrive"
                                        value={minDrive}
                                        onChange={onMinDriveChange}
                                        type="number"
                                        id="standard-start-adornment"
                                        className={clsx(classes.margin, classes.textField)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">Km</InputAdornment>,
                                            step: 0.1,
                                            inputProps: {
                                                min: 0, step: 0.1,
                                            }
                                        }}
                                    />
                                </FormControl>
                            }
                            {
                                reportType.speedLimit &&
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        variant="standard"
                                        label="Speed Limit"
                                        name="speedLimit"
                                        value={speedLimit}
                                        onChange={onSpeedLimitChange}
                                        type="number"
                                        id="standard-start-adornment"
                                        className={clsx(classes.margin, classes.textField)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">Km/h</InputAdornment>,
                                            step: 0.1,
                                            inputProps: {
                                                min: 5, step: 1,
                                            }
                                        }}
                                    />
                                </FormControl>
                            }
                            {
                                reportType.minTemp &&
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        variant="standard"
                                        label="Minimum Temperature"
                                        name="minTemp"
                                        value={minTemp}
                                        onChange={onMinTempChange}
                                        type="number"
                                        id="standard-start-adornment"
                                        className={clsx(classes.margin, classes.textField)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">°C</InputAdornment>,
                                            step: 0.1,
                                            inputProps: {
                                                min: -100, step: 0.1,
                                            }
                                        }}
                                    />
                                </FormControl>
                            }
                            {
                                reportType.maxTemp &&
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        variant="standard"
                                        label="Maximum Temperature"
                                        name="maxTemp"
                                        value={maxTemp}
                                        onChange={onMaxTempChange}
                                        type="number"
                                        id="standard-start-adornment"
                                        className={clsx(classes.margin, classes.textField)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">°C</InputAdornment>,
                                            step: 0.1,
                                            inputProps: {
                                                min: -100, step: 0.1,
                                            }
                                        }}
                                    />
                                </FormControl>
                                }
                                {
                                reportType.interval &&
                                <FormControl className={classes.formControl}>
                                    {
                                        Array.isArray(reportType.intervalOptions) ?
                                            <>
                                                <InputLabel id="reportIntervalLabel">Report Interval</InputLabel>
                                                <Select
                                                    variant="standard"
                                                    labelId="reportIntervalLabel"
                                                    id="reportIntervalSelect"
                                                    value={interval}
                                                    onChange={onIntervalChange}
                                                >
                                                    {
                                                        reportType.intervalOptions.map(value => (
                                                            <MenuItem key={value} value={value}>{value} Minutes</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </>
                                            :
                                            <TextField
                                                variant="standard"
                                                label="Report Interval"
                                                name="interval"
                                                value={interval}
                                                onChange={onIntervalChange}
                                                type="number"
                                                id="standard-start-adornment"
                                                className={clsx(classes.margin, classes.textField)}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="start">Minutes</InputAdornment>,
                                                    step: 0.1,
                                                    inputProps: {
                                                        min: 5, step: 5,
                                                    }
                                                }}
                                            />
                                    }
                                </FormControl>
                            }
                            {
                                reportType.accurateKmOption &&
                                <FormControl className={classes.formControl}>
                                    <FormControlLabel
                                        control={<Checkbox checked={accurateKm} onChange={() => setAccurateKm(!accurateKm)} name="accurateKm" />}
                                        label="Use GPS distance calculation"
                                    />
                                    <Typography variant="subtitle2">
                                        Default mode uses odometer distance. GPS distance can be used when odometer offset data is not suitable.
                                    </Typography>
                                </FormControl>
                            }
                            {
                                reportType.zoneSelect &&
                                <ZoneMultiSelect
                                    multiZones={multiZones}
                                    setMultiZones={setMultiZones}
                                    multiZoneIds={multiZoneIds}
                                    setMultiZoneIds={setMultiZoneIds}
                                />
                            }
                            {/*
                                reportType.compliance &&
                                <FormControlLabel
                                    control={<Checkbox checked={compliance} onChange={() => setCompliance(!compliance)} name="Advanced" />}
                                    label={<span style={{ color: 'red' }}><b>Enable Compliance Check</b></span>}
                                />
                            */}
                        </DialogContent>
                    }
                </Grid>

                {
                    reportSupportsPdf &&
                    <Grid item sm={12}><Divider /></Grid>
                }


                {
                    reportSupportsPdf &&
                    <Grid item sm={12}>
                    <DialogContent>
                        <FormLabel component="legend">Report Delivery Options</FormLabel>
                        <FormGroup row>

                            <FormControlLabel
                                control={<Checkbox checked={emailPDF} onChange={() => onEmailPdfChange(emailPDF)} name="Email" />}
                                label="Send in Email"
                            />
                            {
                                reportType.mapOption && emailPDF &&
                                <FormControlLabel
                                    control={<Checkbox checked={mapNeeded} onChange={() => setMapNeeded(!mapNeeded)} name="Include Map" />}
                                    label="Include Route Map in PDF report"
                                />
                            }
                        </FormGroup>
                    </DialogContent>
                    {
                        emailPDF &&
                        <DialogContent>
                            <Typography variant="body1"><b style={{ color: 'DodgerBlue' }}>Email Address</b></Typography>
                            <DialogContentText>
                                Please add third party email addresses for directly sending the report. You can add multiple email addresses here.
                            </DialogContentText>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <TextField
                                        autoFocus
                                        id="name"
                                        label="Add Email Address"
                                        type="email"
                                        value={currentEmail}
                                        onChange={(e) => setCurrentEmail(e.target.value)}
                                        variant="filled"
                                        size="small"
                                    />

                                </Grid>
                                <Grid container item alignItems="stretch" style={{ display: "flex" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={addEmails} disabled={!validateEmail(currentEmail)}>
                                        <AddCircleOutlineIcon fontSize="large" />
                                    </Button>
                                </Grid>
                                <Grid item sm={12}>
                                    {
                                        emails.map(e =>
                                            <Chip
                                                size="small"
                                                label={e}
                                                onDelete={() => emailDelete(e)}
                                                key={e}
                                                color="primary"
                                                variant="outlined"
                                                style={{ margin: '5px' }}
                                            />
                                        )
                                    }
                                </Grid>
                            </Grid>
                        </DialogContent>
                    }
                </Grid>
                }
            </Grid>
            <Grid item sm={12}>

                {
                    formerr.length > 0 &&
                    <ul>
                        {formerr.map((e, i) => <li key={i}> <Typography><span style={{ color: 'red' }}>{e}</span></Typography></li>)}
                    </ul>
                }

            </Grid>
            <DialogActions>
                <Button onClick={closeForm} color="secondary" variant="contained">
                    Cancel
                </Button>
                <Button onClick={resetForm} variant="contained">
                    Reset Form
                </Button>
                <Button onClick={() => submitForm()} color="primary" disabled={submitDisabled} variant="contained">
                    Build Report
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default GetReportForm;
